import axios from "axios";

const searchLegislators = async (userSelectedSession, limit, offset) => {
  const response = await axios.post(
    `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/search?limit=${limit}&offset=${offset}`,
    {
      sessionIds: [userSelectedSession],
    }
  );
  console.log({response});
  return response.data;
};

const getAllLegislatorsFromWordpress = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_WORDPRESS_API_URL}/v1/legislators/`
  );
  return response.data.content;
};

const getLegislatorUsingId = async (id) => {
  const response = await axios.get(
    `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/${id}`
  );
  return response.data;
};

const getLegislatorUsingEmail = async (email) => {
  const response = await axios.get(
    `https://www.legmt.gov/wp-json/legmt/v1/legislators/findByEmail?email=${email}`
  );
  return response.data;
};

const filterLegislatorsWithEndDate = (legislators) => {
  if (!legislators) return [];
  // Return the filtered array directly, don't try to access .content again
  return legislators.content.map((legislator) => ({
    id: legislator.id,
    firstName: legislator.firstName,
    lastName: legislator.lastName,
    email: legislator.emailAddress,
    telephone: legislator.phoneNumber,
    addressLine1: null, // Not provided in API
    addressLine2: null, // Not provided in API
    city: legislator.city,
    state: "MT",
    postalCode: null, // Not provided in API
    title: legislator.chamber === "SENATE" ? "Senator" : "Representative",
    chamber: legislator.chamber,
    district:
      (legislator.chamber === "SENATE" ? "SD " : "HD ") +
      legislator.district.number.toString(),
    party: legislator.politicalParty.code,
    status: (() => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const startDate = new Date(legislator.startDate);
      startDate.setHours(0, 0, 0, 0);
      
      if (legislator.endDate) {
        const endDate = new Date(legislator.endDate);
        endDate.setHours(0, 0, 0, 0);
        
        if (today >= startDate && today <= endDate) {
          return "Active";
        }
        if (today > endDate) {
          return "Former";
        }
      }

      if (today >= startDate) {
        return "Active";
      }
      return "Former";
    })()
  }));
};

const getLegislatorsFromWordpressWithEmails = async (emails) => {
  console.log({emails})
  const validEmails = (emails || []).filter(email => 
    typeof email === 'string' && email.trim().length > 0
  ); 

  if (validEmails.length === 0) {
    return [];
    return [];
  }

  const response = await axios.post(
    `${process.env.REACT_APP_WORDPRESS_API_URL}/v1/legislators/findByEmails`,
    {
      emails: validEmails, 
      emails: validEmails, 
    }
  );
  return response.data;
};

export {
  searchLegislators,
  getLegislatorUsingId,
  getLegislatorUsingEmail,
  filterLegislatorsWithEndDate,
  getLegislatorsFromWordpressWithEmails,
  getAllLegislatorsFromWordpress,
};
